import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../../../store/root-reducer';
import { saveAiSeqGeneratorStepDetailsRequest } from '../../../../../extra-actions';
import { SequenceEmailContent } from '../../../type';
import SequenceEditStep from './sequence-edit-step';
import {
  setRegeneratedStep,
  updateAISequenceEmails,
} from '../../../../../sequence-slice';

interface SequenceEditStepContainerProps {
  handleModalClose: () => void;
  saveCurrentStepDetails?: (payload: any) => void;
}

const SequenceEditStepContainer: React.FC<SequenceEditStepContainerProps> = ({
  saveCurrentStepDetails,
}) => {
  const dispatch = useDispatch();
  const {
    sessionId,
    currentStep,
    data: { sequence },
    regeneratedStep,
  } = useSelector((state: RootState) => state?.sequence?.generateAiSeqModal);

  const { status } = useSelector(
    (state: RootState) => state.sequence?.saveAiSeqGeneratorStepDetailsRequest,
  );

  const setRegeneratedStepValue = useCallback(
    (payload: SequenceEmailContent) => {
      dispatch(setRegeneratedStep(payload));
    },
    [],
  );

  const handleRegenerateSequenceContent = useCallback(
    (payload: SequenceEmailContent & { userPrompt: string }) => {
      const {
        subject,
        content,
        order,
        day,
        remainingRegenrationQuota,
        userPrompt,
      } = payload;
      dispatch(
        saveAiSeqGeneratorStepDetailsRequest({
          sessionId,
          stepName: currentStep,
          isRegenerate: true,
          data: {
            emails: [
              {
                subject,
                content,
                order,
                day,
                remainingRegenrationQuota,
              },
            ],
            userPrompt,
          },
        }),
      );
    },
    [sessionId, currentStep],
  );

  const handleUpdateAISequenceEmails = useCallback((steps: any[]) => {
    dispatch(updateAISequenceEmails(steps));
  }, []);

  return (
    <SequenceEditStep
      sequenceList={sequence}
      handleRegenerateSequenceContent={handleRegenerateSequenceContent}
      handleUpdateAISequenceEmails={handleUpdateAISequenceEmails}
      regeneratedStep={regeneratedStep}
      saveCurrentStepDetails={saveCurrentStepDetails}
      setRegeneratedStepValue={setRegeneratedStepValue}
      saveAiSeqGeneratorStepDetailsRequestStatus={status}
    />
  );
};

export default memo(SequenceEditStepContainer);
